import DataTranslator from "../netGraph/DataProcessing/DataTranslator";

export function processNetgraphData(inputData) {

	const dataDb = translateFromCurrentToDb(inputData);
	const data = translateFromDbToNetgraph(dataDb);
	return data;
}

function translateFromCurrentToDb(rawData) {
	let data = [];
	for (let i = 0; i < rawData.length; i++) {
		const element = rawData[i];
		data.push(Object.assign({}, element));
	}
	for (let i = 0; i < data.length; i++) {
		const master = data[i];
		// !! Remove when thumbnail_url stops being used !!
		if (master.thumbnail_url) {
			if (master.thumbnail_url.public_url) master.media_url = master.thumbnail_url.public_url;
			else master.media_url = master.thumbnail_url;
			delete master.thumbnail_url;
		}
		// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
		if (master.features) {
			let slaves = master.features;
			if (slaves?.length) {
				slaves = slaves.filter(e => e !== null && e !== undefined);
				master.children = slaves;
			} else {
				master.children = [];
			}
			delete master.features;
		}
	}
	return data;
}

function translateFromDbToNetgraph(rawData) {
	const data = new DataTranslator().compute(rawData);
	return data;
}